import { FleetUUIDs } from '../enums';
import { useFleetOverride } from '../queries';
import { useHasAccess } from './useHasAccess';

const fleetsWithAssetManagement = [FleetUUIDs.SacRTBusStopShelter, FleetUUIDs.SacRTBusStopShelterActivePilot];

export const useAssetManagement = (): boolean => {
  const { data: fleetUUID } = useFleetOverride();
  if (!fleetUUID) {
    return false;
  }

  return fleetsWithAssetManagement.includes(fleetUUID as FleetUUIDs);
};

export const useAssetManagementForCustomer = (): boolean => {
  const hasAccess = useHasAccess();
  const isAssetManagement = useAssetManagement();

  if (isAssetManagement && !hasAccess) {
    return true;
  }
  return false;
};

// Kept as the single gate for the enlarged license plate view: the MBTA glare workaround
// (CLOUD-7748) was reverted, so no fleet is restricted for now.
export const useCanViewLargeLicensePlate = (): boolean => {
  // No fleet is restricted for viewing large license plates at the moment.
  return true;
};
